import { useTranslation } from 'react-i18next';

export default function Services() {
  const { t } = useTranslation();

  const services = [
    {
      icon: 'ri-scales-3-line',
      titleKey: 'services.nutrition.title',
      descKey: 'services.nutrition.description',
      features: [
        'services.nutrition.feature1',
        'services.nutrition.feature2',
        'services.nutrition.feature3'
      ],
      image: 'https://public.readdy.ai/ai/img_res/14bbd4c6aa708d8b48dbb7ece72918c2.jpg'
    },
    {
      icon: 'ri-truck-line',
      titleKey: 'services.tracking.title',
      descKey: 'services.tracking.description',
      features: [
        'services.tracking.feature1',
        'services.tracking.feature2',
        'services.tracking.feature3'
      ],
      image: 'https://readdy.ai/api/search-image?query=Fresh%20meal%20delivery%20truck%20with%20eco-friendly%20packaging%2C%20modern%20delivery%20service%2C%20professional%20branding%2C%20clean%20urban%20setting&width=400&height=300&seq=delivery&orientation=landscape'
    },
    {
      icon: 'ri-chef-hat-line',
      titleKey: 'services.delivery.title',
      descKey: 'services.delivery.description',
      features: [
        'services.delivery.feature1',
        'services.delivery.feature2',
        'services.delivery.feature3'
      ],
      image: 'https://readdy.ai/api/search-image?query=Professional%20chef%20preparing%20healthy%20meals%20in%20modern%20commercial%20kitchen%2C%20fresh%20ingredients%2C%20gourmet%20presentation%2C%20high%20quality%20food%20preparation&width=400&height=300&seq=chef-prep&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('services.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <img
                src={service.image}
                alt={t(service.titleKey)}
                className="w-full h-48 object-cover"
              />
              <div className="p-8">
                <div className="bg-teal-100 w-16 h-16 rounded-full flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-2xl text-teal-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">
                  {t(service.titleKey)}
                </h3>
                <p className="text-gray-600 mb-6">
                  {t(service.descKey)}
                </p>
                <ul className="space-y-3">
                  {service.features.map((featureKey, featureIndex) => (
                    <li key={featureIndex} className="flex items-start space-x-3">
                      <i className="ri-check-line text-teal-600 mt-1"></i>
                      <span className="text-gray-700">{t(featureKey)}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Features Section */}
        <div className="mt-20 bg-white rounded-2xl p-8 md:p-12">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                How MacroFit Meals Works
              </h3>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="bg-teal-100 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-teal-600 font-bold">1</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Choose Your Plan</h4>
                    <p className="text-gray-600">Select the meal plan that fits your goals and lifestyle.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="bg-teal-100 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-teal-600 font-bold">2</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">We Prepare Fresh</h4>
                    <p className="text-gray-600">Our chefs prepare your meals fresh daily with premium ingredients.</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="bg-teal-100 w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-teal-600 font-bold">3</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Delivered to You</h4>
                    <p className="text-gray-600">Receive your macro-balanced meals delivered fresh to your door.</p>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img
                src="https://readdy.ai/api/search-image?query=Step%20by%20step%20meal%20delivery%20process%2C%20meal%20prep%20containers%20being%20packed%2C%20delivery%20truck%2C%20happy%20customer%20receiving%20meals%2C%20infographic%20style%2C%20professional%20photography&width=500&height=400&seq=process&orientation=landscape"
                alt="MacroFit Meals Process"
                className="rounded-xl shadow-lg w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}